export default __webpack_public_path__ + "static/everett-regular-webfont-03035841a4efc1ec863ff12ab27be269.woff";